import { State } from "./state";
import Mutations from "./mutations";
import Getters from "./getters";
import Actions from "./actions";
export default class TheoryPreExams {
    namespaced = true;
    state;
    mutations = Mutations;
    getters = Getters;
    actions = Actions;
    constructor() {
        this.state = new State();
    }
}
